var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_c('span', {
    directives: [{
      name: "m-r",
      rawName: "v-m-r",
      value: 4,
      expression: "4"
    }],
    domProps: {
      "textContent": _vm._s(_vm.displayMonth)
    }
  }), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.displayYear)
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }